import { Button, Checkbox, TextInput } from '@mantine/core';
import { useForm } from '@mantine/form';
import { notifications } from '@mantine/notifications';
import React from 'react';
import { useNavigate } from 'react-router';

import { storageKeys } from '../../../../app/config';
import { rootRoutes } from '../../../../app/routers/rootRoutes';
import { ReactComponent as Lock } from '../../../../shared/assets/lock.svg';
import { ReactComponent as User } from '../../../../shared/assets/user.svg';
import { texts } from '../../../../shared/config';
import { useAuthMutation } from '../../model/api/authApi';
import styles from './AuthForm.module.css';
import classes from './FloatingLabelInput.module.css';

interface FormValues {
  login: string;
  password: string;
  rememberMe: boolean;
}

Object.assign(classes, { input: styles.field });

export const AuthForm = () => {
  const navigate = useNavigate();
  const [focused, setFocused] = React.useState('');

  const [setAuth] = useAuthMutation();

  const form = useForm<FormValues>({
    mode: 'uncontrolled',
    name: 'auth',
    initialValues: {
      login: '',
      password: '',
      rememberMe: false,
    },
    validate: (values) => ({
      login: values.login.trim() ? null : 'Введите логин',
      password: values.password.trim() ? null : 'Введите пароль',
    }),
    validateInputOnChange: true,
  });

  const handleSubmit = (values: FormValues) => {
    setAuth(values)
      .unwrap()
      .then((data) => {
        localStorage.setItem(storageKeys.token, data.token);
        navigate(rootRoutes.taskList);
      })
      .catch((error) => {
        notifications.show({
          message: error.data?.LogonResult?.error ?? texts.defaultError,
          color: 'red',
        });
      });
  };
  const login = form.getInputProps('login');
  const password = form.getInputProps('password');
  const floatingLogin = login.defaultValue.trim().length !== 0 || focused === 'login' || undefined;
  const floatingPassword = password.defaultValue.trim().length !== 0 || focused === 'password' || undefined;

  return (
    <div className={styles.root} data-id="authForm">
      <form onSubmit={form.onSubmit(handleSubmit)}>
        <div className={styles.fieldBlock} data-id="loginField">
          <div className={styles.icon}>
            <User data-id="iconAuthLogin" />
          </div>
          <TextInput
            {...login}
            withAsterisk
            autoComplete="nope"
            className={styles.fieldRoot}
            classNames={classes}
            data-floating={floatingLogin}
            key={form.key('login')}
            label="Логин"
            labelProps={{ 'data-floating': floatingLogin }}
            radius={0}
            size="md"
            onBlur={() => setFocused('')}
            onFocus={() => setFocused('login')}
          />
        </div>

        <div className={styles.fieldBlock} data-id="passwordField">
          <div className={styles.icon}>
            <Lock data-id="iconAuthPassword" />
          </div>
          <TextInput
            {...password}
            withAsterisk
            autoComplete="nope"
            className={styles.fieldRoot}
            classNames={classes}
            data-floating={floatingLogin}
            key={form.key('password')}
            label="Пароль"
            labelProps={{ 'data-floating': floatingPassword }}
            radius={0}
            size="md"
            type="password"
            onBlur={() => setFocused('')}
            onFocus={() => setFocused('password')}
          />
        </div>

        <div className={styles.actions}>
          <Checkbox
            label="Запомнить"
            key={form.key('rememberMe')}
            {...form.getInputProps('rememberMe', { type: 'checkbox' })}
          />
          <Button type="submit" variant="subtle">
            Войти
          </Button>
        </div>
      </form>
    </div>
  );
};
